import {Point} from './point';
import {AutomatModel} from './automatModel';

export class EditAutomat {
  _id?: string;
    name: string;
    firm: string;
    modalName: string;
    serial: string;
    external_id?: string;
    maxProductPrice: number;
    operator: string;
    group: string;
    automatModel: {
      _id?: string;
      automatBrand: {
        _id?: string;
      };
    };
    province: string;
    district: string;
    neighborhood: string;
    description: string;
    device: string;
    vPos: string;
    beacon: string;
    sim: string;
    modem: string;
    location: Point = new Point();
    isCoin: boolean;
    isCard: boolean;
    isTelemetry: boolean;
    isPreSalesCard: boolean;
    isMobil: boolean;
    isStock: number;
    isEndOfAutomatSale: boolean;
    headStart: number;
    automatPaymentSystemId: string;
    automatPaymentSystemName: string;
  
    constructor() {
      this.name = null;
      this.firm = null;
      this.modalName = null;
      this.serial = null;
      this.description = null;
      this.automatModel = {
        automatBrand: {
          _id: null,
        },
        _id: null
      };
      this.operator = null;
      this.group = null;
      this.province = null;
      this.district = null;
      this.neighborhood = null;
      this.device = null;
      this.vPos = null;
      this.beacon = null;
      this.sim = null;
      this.modem = null;
      this.isCoin = false;
      this.isCard = false;
      this.isPreSalesCard = false;
      this.isMobil = false;
      this.automatPaymentSystemId = null;
    }
}



// WEBPACK FOOTER //
// /home/escobar/Documents/Projects/E-VEND/Srl-Evend/FE/superadmin/src/app/models/editAutomat.ts